
import useStore from "@/composables/useStore";
import { computed, defineComponent, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
// eslint-disable-next-line
// @ts-ignore no TS types provided
import { Modal } from "vue-neat-modal";
import "vue-neat-modal/dist/vue-neat-modal.css";
import DiamondProperties from "@/components/DiamondProperties.vue";
import DiamondColorDiagram from "@/components/DiamondColorDiagram.vue";
import DiamondClarityDiagram from "@/components/DiamondClarityDiagram.vue";

export default defineComponent({
    name: "DiamondInfoModal",
    components: {
        DiamondClarityDiagram,
        DiamondColorDiagram,
        DiamondProperties,
        Modal,
    },
    setup() {
        const store = useStore();
        const isOpen = computed({
            get() {
                return store.state.showInfoModal;
            },

            set(value: boolean) {
                store.actions.setShowInfoModal(value);
            },
        });

        const showIFrame = ref(false);

        function handleIFrameLoaded() {
            showIFrame.value = true;
        }

        const selectedDiamond = computed(() => store.state.infoSelectedDiamond);

        const certificateUrl = computed(
            () => store.state.infoSelectedDiamond?.certificateLink
        );

        const carat = computed(() => store.state.infoSelectedDiamond?.carat);
        const shape = computed(() => store.state.infoSelectedDiamond?.shape);
        const clarity = computed(
            () => store.state.infoSelectedDiamond?.clarity
        );
        const color = computed(() => store.state.infoSelectedDiamond?.color);
        const cut = computed(() => store.state.infoSelectedDiamond?.cut);
        const videoLink = computed(
            () => store.state.infoSelectedDiamond?.videoLink
        );
        const productId = computed(() => store.state.infoSelectedDiamond?.sku);

        watch(videoLink, () => {
            showIFrame.value = false;
        });

        return {
            ...useI18n(),
            isOpen,
            selectedDiamond,
            certificateUrl,
            carat,
            shape,
            clarity,
            color,
            cut,
            videoLink,
            productId,
            showIFrame,
            handleIFrameLoaded,
        };
    },
});
